import { Backdrop } from '@loomhq/lens';
import React, { Suspense, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeModal, openModal } from 'actions/modals';
import { isProduction } from 'constants/environment';
import { getParam } from 'utilities/url';

import ModalComponents from './ModalComponents';

const modalParam = isProduction ? null : getParam('modal');

const ModalContainer = () => {
  const modalType = useSelector(state => state.modals?.modalType);
  const options = useSelector(state => state.modals?.options ?? {});
  const dispatch = useDispatch();

  const closeModalCallback = useCallback(
    () => dispatch(closeModal()),
    [dispatch]
  );
  const openModalCallback = useCallback(
    () => dispatch(openModal({ modalType, options })),
    [modalType, options, dispatch]
  );

  let ActiveModal;

  if (modalType) {
    ActiveModal = ModalComponents[modalType];
  } else if (modalParam) {
    ActiveModal = ModalComponents[modalParam];
  } else {
    return null;
  }

  return (
    <Suspense fallback={<Backdrop isOpen />}>
      <ActiveModal
        {...options}
        openModal={openModalCallback}
        closeModal={closeModalCallback}
      />
    </Suspense>
  );
};

export default ModalContainer;
